export const hydrateFormData = (data: any) => {
	const iosData: { [key: string]: any } = {};
	const androidData: { [key: string]: any } = {};

	data.configs.forEach((item: any) => {
		const versionRange = `${item.minAppVersion}-${item.maxAppVersion}`;
		const configData = {
			url: item.url,
			fileName: item.url.split('/').pop(),
			expiry: new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1000).getTime(),
			backgroundColor: item.backgroundColor
		};

		if (item.deviceType === 'IOS') {
			iosData[versionRange] = configData;
		} else if (item.deviceType === 'ANDROID') {
			androidData[versionRange] = configData;
		}
	});

	return {
		success: true,
		data: {
			splashIOS: iosData,
			splashAndroid: androidData
		}
	};
};

export const convertSplashConfig = (result: any) => {
	const config: any[] = [];
	const value = result?.data?.value || {};
	// Handle iOS splash configs
	if (value.splashIOS) {
		Object.entries(value.splashIOS).forEach(([versionRange, data]: [string, any]) => {
			const [minVersion, maxVersion] = versionRange.split('-').map(Number);
			config.push({
				url: data.url,
				fileName: data.fileName,
				expiry: data.expiry,
				backgroundColor: data.backgroundColor,
				deviceType: 'IOS',
				minAppVersion: minVersion,
				maxAppVersion: maxVersion || 10000,
				isPreProd: result.data.isPreProd
			});
		});
	}

	// Handle Android splash configs
	if (value.splashAndroid) {
		Object.entries(value.splashAndroid).forEach(([versionRange, data]: [string, any]) => {
			const [minVersion, maxVersion] = versionRange.split('-').map(Number);
			config.push({
				url: data.url,
				fileName: data.fileName,
				expiry: data.expiry,
				backgroundColor: data.backgroundColor,
				deviceType: 'ANDROID',
				minAppVersion: minVersion,
				maxAppVersion: maxVersion || 10000,
				isPreProd: result.data.isPreProd
			});
		});
	}

	return {
		success: true,
		data: {
			config,
			count: config.length
		}
	};
};

export const formatSplashConfig = (response: { data: any[] }) => {
	return {
		configs: response.data.map((item: any) => {
			const formattedItem = {
				...item,
				expiry: item.expiry ? new Date(item.expiry).toISOString().split('T')[0] : '',
				id: item._id, // Use _id directly
				key: item._id // Add key property for form identification
			};
			return formattedItem;
		})
	};
};
